
import React, { FC } from 'react'

interface DividerProps {
    className: string
}

const Divider: FC<DividerProps> = ({ className }) => {
    return (
        <svg className={className} width="294" height="1" viewBox="0 0 294 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="0.5" x2="294" y2="0.5" stroke="#E2EDF8" />
        </svg>


    )
}

export default Divider


